//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    isArabicLanguage: function () {
      return this.$i18n.locale === 'ar';
    }
  },
  methods: {
    change: function () {
      this.$emit("change");
    },
  }
}
